



























// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { Dictionary } from "@/utils/types";
import { matchWildcard } from "@/utils/regex";

const options = [
	{
		title: "Home",
		route:"home",
		icon:"mdi.home",
		match:"/home*"
	},
	{
		title: "Assets",
		route:"assets",
		icon:"mdi.layers",
		match:"/assets*"
	},
	{
		title: "Studies",
		route:"studies",
		icon:"mdi.rocket",
		match:"/studies*"
	},
	{
		title: "Tags",
		route:"view-tags",
		icon:"mdi.tag-multiple",
		match:"/tags*"
	}
];

export default defineComponent({
	emits:[
		"close-menu"
	],
	props:{
	},
	components:{
	},
	setup(props, context){

		const navOptions = computed(() => options);

		const getRoute = (index:number) => {
			const option = navOptions.value[index];
			const q:any = {};

			[ "t" ].forEach(qk => {
				if(context.root.$route.query[qk]){
					q[qk] = context.root.$route.query[qk];
				}
			});

			return {
				name:option.route,
				query:q
			}
		};

		const isRoute = (option:any) => {
			return matchWildcard(context.root.$route.path, option.match);
		};
	
		const isExactRoute = (option:any) => {
			return option.route === context.root.$route.name;
		};

		const hideMenu = () => {
			context.emit("close-menu");
		};

		return {
			navOptions,
			isRoute,
			isExactRoute,
			hideMenu,
			getRoute,
		};

	}
});
